(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var campaignKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'fbclid'
  ];
  var campaignStorageKey = 'cantina_campaign_context';
  var currentParams = new URLSearchParams(window.location.search);
  var campaignValues = {};

  campaignKeys.forEach(function (key) {
    var value = currentParams.get(key);
    if (value) campaignValues[key] = value;
  });

  function customerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy
      ? window.Shopify.customerPrivacy
      : null;
  }

  function storageAllowedFor(key) {
    var privacy = customerPrivacy();
    if (!privacy) return false;

    try {
      if (key === 'gclid' || key === 'fbclid') {
        return typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed();
      }

      return (
        (typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed()) ||
        (typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed())
      );
    } catch (error) {
      return false;
    }
  }

  function refreshStoredCampaignContext() {
    var stored = {};

    try {
      stored = JSON.parse(window.sessionStorage.getItem(campaignStorageKey) || '{}');
    } catch (error) {
      stored = {};
    }

    campaignKeys.forEach(function (key) {
      if (!storageAllowedFor(key)) {
        delete stored[key];
        return;
      }

      if (!campaignValues[key] && stored[key]) campaignValues[key] = stored[key];
      if (campaignValues[key]) stored[key] = campaignValues[key];
    });

    try {
      if (Object.keys(stored).length) {
        window.sessionStorage.setItem(campaignStorageKey, JSON.stringify(stored));
      } else {
        window.sessionStorage.removeItem(campaignStorageKey);
      }
    } catch (error) {
      return;
    }
  }

  function updatePlateformLinks() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var url;

      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.hostname !== 'cantinaantica.plateform.app') return;

      campaignKeys.forEach(function (key) {
        if (campaignValues[key] && !url.searchParams.has(key)) {
          url.searchParams.set(key, campaignValues[key]);
        }
      });

      link.href = url.toString();
    });
  }

  function refreshCampaignContext() {
    refreshStoredCampaignContext();
    updatePlateformLinks();
  }

  updatePlateformLinks();

  if (customerPrivacy()) {
    refreshCampaignContext();
  } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) refreshCampaignContext();
      }
    );
  }

  document.addEventListener('visitorConsentCollected', refreshCampaignContext);

  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-track]');
    if (!trigger) return;

    var destination = trigger.getAttribute('href') || '';
    window.dataLayer.push({
      event: trigger.dataset.track,
      link_url: destination,
      link_text: (trigger.textContent || '').trim(),
      page_path: window.location.pathname,
      cta_location: trigger.dataset.trackLocation || 'unspecified'
    });
  });

  document.querySelectorAll('.mobile-nav a').forEach(function (link) {
    link.addEventListener('click', function () {
      var menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  });

  var cookieButton = document.querySelector('[data-cookie-preferences]');
  if (cookieButton) {
    function getPrivacyPreferencesController() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        return function () {
          window.privacyBanner.showPreferences();
        };
      }

      var nativeButton = document.querySelector(
        '#shopify-privacy-banner-button-div button, [data-shopify-privacy-settings-button]'
      );

      if (nativeButton && nativeButton !== cookieButton) {
        return function () {
          nativeButton.click();
        };
      }

      return null;
    }

    function syncCookieButton() {
      cookieButton.hidden = !getPrivacyPreferencesController();
    }

    cookieButton.addEventListener('click', function () {
      var openPreferences = getPrivacyPreferencesController();
      if (openPreferences) openPreferences();
      else cookieButton.hidden = true;
    });

    [0, 500, 1500, 3000].forEach(function (delay) {
      window.setTimeout(syncCookieButton, delay);
    });
  }
})();
